import { render, staticRenderFns } from "./rc-link.vue?vue&type=template&id=3c2b7a44&scoped=true&"
import script from "./rc-link.vue?vue&type=script&lang=js&"
export * from "./rc-link.vue?vue&type=script&lang=js&"
import style0 from "./rc-link.vue?vue&type=style&index=0&id=3c2b7a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2b7a44",
  null
  
)

export default component.exports